import { Component, Vue, Prop } from 'vue-property-decorator';

@Component<RequestButtonDataTable>({})
export default class RequestButtonDataTable extends Vue {
  @Prop()
  protected value!: RequestViewType;

  protected buttonViewType: RequestViewType = 'data-table';

  protected handleClick(): void {
    this.$emit('input', this.buttonViewType);
  }

  protected get isActive(): boolean {
    return this.value === this.buttonViewType;
  }
}

export type RequestViewType = 'data-table' | 'kanban';
